import classNames from 'classnames';
import React from 'react';

import { StandardButton, LinkButton } from '@eika/button';
import '@eika/card-style/src/MarketCard/index.scss';

import { IllustrationHeader, ImageHeader, RichIconHeader } from './MarketCard/MarketCardHeader';
import { MarketCardProps, MarketCardComposition } from './MarketCard/types';

const MarketCard: React.FC<MarketCardProps> & MarketCardComposition = ({
    className,
    header,
    title,
    children,
    primaryButton,
    secondaryButton,
    useSpanningBackdrop = false,
    ...rest
}) => {
    return (
        <section
            className={classNames('sgw-market-card', className, {
                'sgw-market-card--full-width': useSpanningBackdrop,
            })}
            {...rest}
        >
            <div
                className={classNames('sgw-market-card__container', {
                    'sgw-market-card__container--has-header': !!header,
                })}
            >
                {header}
                <div className="sgw-market-card__content">
                    {title && <h2 className="sgw-market-card__title light">{title}</h2>}
                    {children && <div className="sgw-market-card__description">{children}</div>}
                    <div className="sgw-market-card__action-wrapper">
                        {primaryButton && <div className="sgw-market-card__button">{primaryButton}</div>}
                        {secondaryButton && <div className="sgw-market-card__button">{secondaryButton}</div>}
                    </div>
                </div>
            </div>
        </section>
    );
};

MarketCard.ImageHeader = ImageHeader;
MarketCard.IllustrationHeader = IllustrationHeader;
MarketCard.PrimaryButton = StandardButton;
MarketCard.SecondaryButton = LinkButton;
MarketCard.RichIconHeader = RichIconHeader;

export default MarketCard;
